import React from 'react';
import Heart from 'lucide-react/dist/esm/icons/heart.js';

export default function PartnerBanner({ partner }) {
  if (!partner || !partner.partner_name) {
    return null;
  }

  return (
    <div className="bg-gradient-to-br from-rose-50 via-pink-50 to-red-50 dark:from-rose-900/20 dark:via-pink-900/20 dark:to-red-900/20 rounded-2xl shadow-lg p-6 border-2 border-rose-200 dark:border-rose-800">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <div className="bg-white dark:bg-gray-800 rounded-xl p-3 shadow-md">
            <Heart className="w-8 h-8 text-rose-600 dark:text-rose-400 fill-current" />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white">
              In Partnership With
            </h3>
          </div>

          <div className="flex items-center gap-4 mb-3">
            {partner.partner_logo_url && (
              <img
                src={partner.partner_logo_url}
                alt={partner.partner_name}
                className="w-16 h-16 rounded-lg object-cover shadow-sm"
              />
            )}
            <div>
              <p className="text-xl font-bold text-rose-900 dark:text-rose-100">
                {partner.partner_name}
              </p>
            </div>
          </div>

          {partner.partner_description && (
            <p className="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
              {partner.partner_description}
            </p>
          )}

          <div className="mt-4 pt-4 border-t border-rose-200 dark:border-rose-800">
            <p className="text-xs text-gray-600 dark:text-gray-400 flex items-center gap-1">
              <Heart className="w-3 h-3 text-rose-500 fill-current" />
              Every ticket purchased supports this amazing cause
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
